/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Business } from './Business';
import {
    BusinessFromJSON,
    BusinessFromJSONTyped,
    BusinessToJSON,
    BusinessToJSONTyped,
} from './Business';

/**
 * 
 * @export
 * @interface UpdateBusinessesImagesBody
 */
export interface UpdateBusinessesImagesBody {
    /**
     * 
     * @type {Array<Business>}
     * @memberof UpdateBusinessesImagesBody
     */
    businesses?: Array<Business>;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessesImagesBody
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessesImagesBody
     */
    headerImage?: string;
}

/**
 * Check if a given object implements the UpdateBusinessesImagesBody interface.
 */
export function instanceOfUpdateBusinessesImagesBody(value: object): value is UpdateBusinessesImagesBody {
    return true;
}

export function UpdateBusinessesImagesBodyFromJSON(json: any): UpdateBusinessesImagesBody {
    return UpdateBusinessesImagesBodyFromJSONTyped(json, false);
}

export function UpdateBusinessesImagesBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessesImagesBody {
    if (json == null) {
        return json;
    }
    return {
        
        'businesses': json['businesses'] == null ? undefined : ((json['businesses'] as Array<any>).map(BusinessFromJSON)),
        'icon': json['icon'] == null ? undefined : json['icon'],
        'headerImage': json['headerImage'] == null ? undefined : json['headerImage'],
    };
}

export function UpdateBusinessesImagesBodyToJSON(json: any): UpdateBusinessesImagesBody {
    return UpdateBusinessesImagesBodyToJSONTyped(json, false);
}

export function UpdateBusinessesImagesBodyToJSONTyped(value?: UpdateBusinessesImagesBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'businesses': value['businesses'] == null ? undefined : ((value['businesses'] as Array<any>).map(BusinessToJSON)),
        'icon': value['icon'],
        'headerImage': value['headerImage'],
    };
}

